import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserAssetsState } from './user-assets.state';

export const selectUserAssetsState = createFeatureSelector<UserAssetsState>('userAssets');

export const selectLoading = createSelector(selectUserAssetsState, state => state.loading);
export const selectDownloadingFile = createSelector(selectUserAssetsState, state => state.downloadingFile);
